import React from 'react';

interface GrammarSettingsProps {
  onError: (error: string | null) => void;
  practicePrompt: string;
  setPracticePrompt: (prompt: string) => void;
}

const GrammarSettings: React.FC<GrammarSettingsProps> = ({ onError, practicePrompt, setPracticePrompt }) => {
  return (
    <div className="space-y-8">
      <h2 className="text-xl font-bold mb-6">Grammar Dictionary Settings</h2>
      
      <div className="bg-white rounded-lg shadow p-6">
        <div className="space-y-6">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Practice Prompt Template
            </label>
            <div className="space-y-2">
              <textarea
                value={practicePrompt}
                onChange={(e) => setPracticePrompt(e.target.value)}
                rows={12}
                className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:ring-talaera-blue focus:border-talaera-blue font-mono text-sm"
                placeholder="Enter the practice prompt template..."
              />
              <div className="text-sm text-gray-500">
                <p className="font-medium mb-2">Available variables from selected grammar feature:</p>
                <div className="grid grid-cols-2 gap-4">
                  <ul className="list-disc list-inside space-y-1">
                    <li><code>{'{{grammarFeature}}'}</code> - The feature name</li>
                    <li><code>{'{{category}}'}</code> - Grammar category</li>
                    <li><code>{'{{description}}'}</code> - Feature description</li>
                    <li><code>{'{{cefrIntroduction}}'}</code> - CEFR introduction level</li>
                    <li><code>{'{{cefrMastery}}'}</code> - CEFR mastery level</li>
                  </ul>
                  <ul className="list-disc list-inside space-y-1">
                    <li><code>{'{{complexityScore}}'}</code> - Complexity score (1-10)</li>
                    <li><code>{'{{businessContexts}}'}</code> - Business usage contexts</li>
                    <li><code>{'{{commonErrors}}'}</code> - Common mistakes</li>
                    <li><code>{'{{importantFootnotes}}'}</code> - Important notes</li>
                  </ul>
                </div>
                <p className="mt-3 text-xs text-gray-400">
                  Use double curly braces for variable substitution. The template will generate exactly 2 multiple choice questions for each grammar feature.
                </p>
              </div>
            </div>
          </div>
          
          <div className="pt-4 border-t border-gray-200">
            <div className="flex items-center space-x-4">
              <div className="flex items-center space-x-2">
                <div className="w-3 h-3 bg-green-500 rounded-full"></div>
                <span className="text-sm text-gray-600">Practice exercises use the existing MCQ framework</span>
              </div>
              <div className="flex items-center space-x-2">
                <div className="w-3 h-3 bg-blue-500 rounded-full"></div>
                <span className="text-sm text-gray-600">Questions include explanations and skill metadata</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GrammarSettings; 